import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=fa81e6c8&scoped=true&"
import script from "./CustomCard.vue?vue&type=script&lang=ts&"
export * from "./CustomCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=fa81e6c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81e6c8",
  null
  
)

export default component.exports